import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import qs from 'qs';
import { actionCreators } from '../../store/ApplicationStore';
import { changeCSS } from '../../utils/themeHelper';

const BrandThemeHandler = ({ location, setTheme }) => {
    useEffect(() => {
        const applyThemeSettings = (themeId) => {
            console.log(`%c Apply Branding Theme ${themeId} `, 'background:orange; color:white; font-weight:bold');
            setTheme(themeId);
            changeCSS(`./styles/themes/brands/${themeId}.css`, 'brand-theme');
        };
        const params = qs.parse(location.search, { ignoreQueryPrefix: true });

        if (params.v) {
            applyThemeSettings(params.v);
            sessionStorage.setItem('brand', params.v);
        } else {
            var brandId = sessionStorage.getItem('brand');
            if (brandId) {
                applyThemeSettings(brandId);
            }
        }
    });
    return <div></div>;
};

export default connect(
    (state) => state.app,
    (dispatch) => bindActionCreators(actionCreators, dispatch)
)(BrandThemeHandler);
